import React, { useState, useRef, useEffect } from "react";
import ModalEditPhoto from "./modals/ModalEditPhoto";
import { v4 as uuid } from "uuid";
import {
  updateBackground,
  dataLookUpConst,
  getAllCards,
  getVCLookUp,
  uploadImage,
  validateDataBackground,
} from "../constants";
import { QRCode } from "react-qrcode-logo";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { bottom_left, bottom_right, top_left, top_right } from "../assets";

const UpdateBackground = ({ data_ }) => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(data_.name);
  const [data, setData] = useState(data_.card);
  const [slug, setSlug] = useState(data_.card.slug);
  const [jobPosition, setJobPosition] = useState(data_.card.job_title);
  const [showError, setShowError] = useState(false);
  const [errrorMsg, setErrorMsg] = useState("");
  const [cards, setCards] = useState([]);
  const [prefix, setPrefix] = useState(data_.card.prefix);
  const [firstName, setFirstName] = useState(data_.card.first_name);
  const [middleName, setMiddleName] = useState(data_.card.middle_name);
  const [lastName, setLastName] = useState(data_.card.last_name);
  const [suffix, setSuffix] = useState(data_.card.suffix);
  const inputFile = useRef(null);

  const [QRStyleIndex, setQRStyleIndex] = useState(
    ["default", "theme", "reverse_theme"].indexOf(data_.qr_style)
  );
  const setQRStyle = (e, ind) => {
    e.preventDefault();
    if (ind == 0) {
      setStyle({
        background: "white",
        qrcolor: "black",
      });
    } else if (ind == 1) {
      setStyle({
        background: colorFirst,
        qrcolor: colorSecond,
      });
    } else {
      setStyle({
        background: colorSecond,
        qrcolor: colorFirst,
      });
    }
    setQRStyleIndex(ind);
  };

  const [QRPositionIndex, setQRPositionIndex] = useState(
    ["top_right", "top_left", "bottom_left", "bottom_right"].indexOf(
      data_.qr_position
    )
  );
  const [position, setPosition] = useState(data_.qr_position.replace("_", "-"));
  const handleOnClickQRPosition = (e, ind) => {
    e.preventDefault();
    if (ind == 0) {
      setPosition("top-right");
    } else if (ind == 1) {
      setPosition("top-left");
    } else if (ind == 2) {
      setPosition("bottom-left");
    } else {
      setPosition("bottom-right");
    }
    setQRPositionIndex(ind);
  };

  const [dataLookup, setDataLookup] = useState(dataLookUpConst);
  const [imageBackground, setImageBackground] = useState(data_.image.url);
  const onButtonClick = (e) => {
    e.preventDefault();
    inputFile.current.click();
  };
  const onDeletePhoto = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (e && e.stopPropagation) e.stopPropagation();
    setCustomImage(null);
    setImageBackground(null);
  };
  const [indexCard, setIndexCard] = useState(0);
  const [images, setImages] = useState([
    {
      lookup_id: "LKP457fd1ca4c8640428e5229b600bb4159",
      category: "virtual_background",
      label: "lake",
      display_label: "Lake",
      base_url: null,
      placeholder: null,
      type: null,
      values: null,
      image_id: "IMGa86fa477ecb840258c5605132fe9cd81",
      image_url:
        "https://cdn.nitomeyocard.com/asset/IMGa86fa477ecb840258c5605132fe9cd81.jpeg",
      created_at: "2025-12-01T16:43:38.848905+00:00",
      updated_at: "2025-12-01T16:43:38.848905+00:00",
    },
    {
      lookup_id: "LKP6c2a8d1d01f34f4a8aad59390ff2afa6",
      category: "virtual_background",
      label: "living_room",
      display_label: "Living Room",
      base_url: null,
      placeholder: null,
      type: null,
      values: null,
      image_id: "IMG54c8ca81df8d458694b2560111af99a3",
      image_url:
        "https://cdn.nitomeyocard.com/asset/IMG54c8ca81df8d458694b2560111af99a3.jpeg",
      created_at: "2025-12-01T16:43:40.806598+00:00",
      updated_at: "2025-12-01T16:43:40.806598+00:00",
    },
    {
      lookup_id: "LKPfc1418f84b7646ba959efaaf7278aa78",
      category: "virtual_background",
      label: "study_room",
      display_label: "Study Room",
      base_url: null,
      placeholder: null,
      type: null,
      values: null,
      image_id: "IMG87be262eb52c48dc9c9debfbc1363238",
      image_url:
        "https://cdn.nitomeyocard.com/asset/IMG87be262eb52c48dc9c9debfbc1363238.jpeg",
      created_at: "2025-12-01T16:43:42.293612+00:00",
      updated_at: "2025-12-01T16:43:42.293612+00:00",
    },
    {
      lookup_id: "LKP2c83c1ac6e434368a0e86782ea064961",
      category: "virtual_background",
      label: "sunset",
      display_label: "Sunset",
      base_url: null,
      placeholder: null,
      type: null,
      values: null,
      image_id: "IMGa3dd04a3033948db9c4ec3c3ad57a97a",
      image_url:
        "https://cdn.nitomeyocard.com/asset/IMGa3dd04a3033948db9c4ec3c3ad57a97a.jpeg",
      created_at: "2025-12-01T16:43:44.231900+00:00",
      updated_at: "2025-12-01T16:43:44.231900+00:00",
    },
    {
      lookup_id: "LKPcab06fa2ba794bcb8b879f401e9fc0bc",
      category: "virtual_background",
      label: "woods",
      display_label: "Woods",
      base_url: null,
      placeholder: null,
      type: null,
      values: null,
      image_id: "IMGba78b486a8b24131969389e677a467a2",
      image_url:
        "https://cdn.nitomeyocard.com/asset/IMGba78b486a8b24131969389e677a467a2.jpeg",
      created_at: "2025-12-01T16:43:46.659725+00:00",
      updated_at: "2025-12-01T16:43:46.659725+00:00",
    },
  ]);
  const [indexBackgroundImage, setIndexBackgroundImage] = useState(() => {
    const image_ids = images.map((val) => val.image_id);
    if (image_ids.indexOf(data_.image.id) == -1) {
      return 99;
    }
    return image_ids.indexOf(data_.image.id);
  });
  const token = user.access_token;
  const [imageEdit, setImageEdit] = useState(null);
  const [funcSetEdit, setFuncSetEdit] = useState(() => setImageBackground);
  const [colorFirst, setColorFirst] = useState(
    "#" + data.color_theme_value.split(",")[0]
  );
  const [colorSecond, setColorSecond] = useState(
    "#" + data.color_theme_value.split(",")[1]
  );
  const [style, setStyle] = useState(() => {
    let background = "white";
    let qrcolor = "black";
    if (QRStyleIndex == 1) {
      background = colorFirst;
      qrcolor = colorSecond;
    } else if (QRStyleIndex == 2) {
      background = colorSecond;
      qrcolor = colorFirst;
    }
    return {
      background: background,
      qrcolor: qrcolor,
    };
  });

  const navigate = useNavigate();

  const handleOnClickUpdateBackground = async (e) => {
    e.preventDefault();
    setLoading(true);
    let dataJson = {
      card_id: data.card_id,
      name: name,
      qr_position: position.replace("-", "_"),
      qr_style: ["default", "theme", "reverse_theme"][QRStyleIndex],
    };
    if (
      imageBackground != null &&
      images.filter((val) => val.image_url == imageBackground).length == 0
    ) {
      if (customImage.includes("http")) {
        dataJson.image_id = data_.image.id;
      } else {
        const background_image_id = await uploadImage(
          token,
          imageBackground,
          "virtual_background"
        );
        dataJson.image_id = background_image_id;
      }
    } else if (imageBackground == null) {
      dataJson.image_id = "";
    } else {
      let chosen = images.filter((val) => val.image_url == imageBackground)[0];
      dataJson.image_id = chosen.image_id;
    }

    let err = validateDataBackground(dataJson);
    if (err != "") {
      toast.error(err, {
        position: "top-center",
        autoClose: 3000,
      });
      setLoading(false);
      return;
    }

    updateBackground(
      token,
      data_.virtual_bg_id,
      dataJson,
      setLoading,
      setShowError,
      setErrorMsg,
      navigate
    );

    console.log(dataJson);
    // setLoading(false);
  };

  useEffect(() => {
    const msg = localStorage.getItem("toastMsg", "");
    getAllCards(token, setCards);
    getVCLookUp(token, setImages);
    if (Boolean(msg)) {
      localStorage.removeItem("toastMsg");
      toast.success(msg, {
        position: "top-center",
        autoClose: 3000,
      });
    }
  }, []);

  useEffect(() => {
    if (showError) {
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [showError]);

  const handleOnChangeTitle = (e) => {
    e.preventDefault();
    setName(e.target.value);
  };

  const handleOnChangeImage = (e, val) => {
    e.preventDefault();
    if (typeof val === "number") {
      setImageBackground(images[val].image_url);
      setIndexBackgroundImage(val);
    } else if (val == "custom") {
      let file = e.target.files?.[0];
      if (!file) return;
      const reader = new FileReader();
      setFuncSetEdit(() => setImageBackground);
      reader.addEventListener("load", () => {
        const imageUrl = reader.result?.toString() || "";
        setImageEdit(imageUrl);
      });
      reader.readAsDataURL(file);
      document.getElementById("edit_photo_modal").showModal();
      setIndexBackgroundImage(99);
    } else {
      setImageBackground(val);
      setIndexBackgroundImage(99);
    }
  };

  const [customImage, setCustomImage] = useState(() => {
    if (indexBackgroundImage == 99) {
      return data_.image.url;
    }
  });

  const styles = ["Default", "Theme", "Reverse Theme"];

  useEffect(() => {
    if (images.filter((val) => val.image_url == imageBackground).length == 0) {
      setCustomImage(imageBackground);
    }
  }, [imageBackground]);

  useEffect(() => {
    if (cards.length > 0) {
      setIndexCard(() => {
        return cards.map((val) => val.card_id).indexOf(data.card_id);
      });
    }
  }, [cards]);

  useEffect(() => {
    if (cards.length > 0) {
      setData({ ...cards[indexCard], name: cards[indexCard].card_name });
    }
  }, [indexCard]);

  useEffect(() => {
    if (Object.keys(data).length != 0) {
      setColorFirst("#" + data.color_theme_value.split(",")[0]);
      setColorSecond("#" + data.color_theme_value.split(",")[1]);
      setPrefix(data.prefix);
      setFirstName(data.first_name);
      setMiddleName(data.middle_name);
      setLastName(data.last_name);
      setSuffix(data.suffix);
      setJobPosition(data.job_title);
      setSlug(data.slug);
    }
  }, [data]);

  return (
    <div className="flex flex-col md:flex-row w-full bg-white h-full overflow-y-auto md:overflow-y-hidden">
      <ToastContainer />
      <div className="flex flex-col border-0 border-r-2 border-r-gray-200 w-full md:w-1/2 px-5 py-5 gap-3 justify-center items-center md:overflow-y-hidden">
        <div className="flex flex-col relative w-full aspect-video bg-gray-400">
          {imageBackground && (
            <img
              src={imageBackground}
              className="absolute top-0 left-0 w-full aspect-video"
            />
          )}
          <div
            className={`flex flex-col w-[12%] rounded-lg items-center pb-2 absolute ${
              position == "top-right"
                ? "top-2 right-2"
                : position == "top-left"
                ? "top-2 left-2"
                : position == "bottom-left"
                ? "bottom-2 left-2"
                : "bottom-2 right-2"
            }`}
            style={{ backgroundColor: style.background, color: style.qrcolor }}
          >
            <QRCode
              id={"qr"}
              value={"https://app.nitomeyocard.com/me/" + slug}
              size={40}
              qrStyle={"dots"}
              logoOpacity={0.15}
              bgColor={"transparent"}
              level={"H"}
              fgColor={style.qrcolor}
            />
            <div className="font-bold text-[6px]">
              {firstName || middleName || lastName
                ? (firstName.split(" ")[0] || "") +
                  " " +
                  (lastName.split(" ").at(-1) || "")
                : "Your name"}
            </div>
            <div className="text-[4px]">{jobPosition}</div>
          </div>
        </div>

        <div
          className="px-10 py-2 bg-primary text-white shadow-lg hover:bg-tertiary active:translate-y-1 cursor-pointer rounded-lg"
          onClick={handleOnClickUpdateBackground}
          id="UpdateBackground"
        >
          {loading ? (
            <div role="status">
              <svg
                aria-hidden="true"
                className="w-6 h-6 text-gray-200 animate-spin fill-secondary"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="white"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="#E47410"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            "Update Background"
          )}
        </div>
      </div>
      <div className="flex flex-col w-full h-full divide-y-[1px] divide-gray-200">
        <div className="flex flex-col w-full justify-start items-start overflow-y-auto h-[83vh]">
          <div className="flex flex-col px-5 pt-5 pb-52 md:py-5 gap-5 w-full overflow-y-auto">
            <div className="flex flex-col">
              <div className="font-bold">Background Profile</div>
              <div className="text-[14px] text-gray-400">
                These fields do not appear in virtual background
              </div>
            </div>
            <div className="flex flex-row w-full items-center">
              <div className="flex flex-row w-4/12 justify-start items-center gap-3">
                <div>Background Title</div>
              </div>
              <input
                className={`flex flex-col border border-black rounded-lg w-3/4 md:w-1/2 h-[40px] px-3 bg-gray-300`}
                onChange={handleOnChangeTitle}
                value={name}
                disabled={true}
              />
            </div>
            <div className="flex flex-row w-full items-center">
              <div className="flex flex-row w-4/12 justify-start items-center gap-3">
                <div>Card</div>
              </div>
              <select
                id="cards"
                className="bg-white border border-gray-400 text-gray-900 rounded-lg focus:outline-blue-500 focus:border-blue-500 block px-3 py-2 w-3/4 md:w-1/2"
                value={indexCard}
                onChange={(e) => setIndexCard(e.target.value)}
              >
                {cards.length > 0 ? (
                  cards.map((val, ind) => (
                    <option key={ind} value={ind}>
                      {val.card_name}
                    </option>
                  ))
                ) : (
                  <option>Card</option>
                )}
              </select>
            </div>
            <div className="flex flex-col gap-2">
              <div className="font-bold">Background Images</div>
              <div className="grid grid-cols-3 gap-2">
                <input
                  type="file"
                  accept="image/*"
                  id="imageBackground"
                  ref={inputFile}
                  className="hidden"
                  onChange={(e) => handleOnChangeImage(e, "custom")}
                />
                {customImage == null ? (
                  <div
                    className={`flex flex-col w-full items-center px-2 py-3 gap-3 rounded-md`}
                    onClick={(e) => {
                      onButtonClick(e);
                    }}
                  >
                    <div className="flex flex-row w-full h-full items-center justify-center border border-gray-200 hover:bg-gray-300 cursor-pointer relative">
                      <div>+</div>
                    </div>
                  </div>
                ) : (
                  <div
                    className={`flex flex-col w-full items-center ${
                      indexBackgroundImage == 99 ? "bg-gray-200" : ""
                    } px-2 py-3 gap-3 rounded-md cursor-pointer relative`}
                    onClick={(e) => handleOnChangeImage(e, customImage)}
                  >
                    <img src={customImage} alt="" />
                    <div className="flex flex-row w-full absolute justify-center h-full items-center gap-10">
                      <div
                        className="flex flex-col px-2 py-1 rounded-lg bg-primary hover:bg-secondary cursor-pointer text-white"
                        onClick={(e) => {
                          if (e && e.stopPropagation) e.stopPropagation();
                          onDeletePhoto(e);
                        }}
                      >
                        delete
                      </div>
                      <div
                        className="flex flex-col px-2 py-1 rounded-lg bg-red-700 hover:bg-red-800 text-white cursor-pointer"
                        onClick={(e) => {
                          onButtonClick(e);
                        }}
                      >
                        replace
                      </div>
                    </div>
                  </div>
                )}
                {images.map((val, ind) => {
                  return (
                    <div
                      key={ind}
                      className={`flex flex-col w-full items-center ${
                        ind == indexBackgroundImage ? "bg-gray-200" : ""
                      } px-2 py-3 gap-3 rounded-md cursor-pointer`}
                      onClick={(e) => handleOnChangeImage(e, ind)}
                    >
                      <img src={val.image_url} alt="" />
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="font-bold">QR Style</div>
              <div className="grid grid-cols-5 gap-2">
                {styles.map((val, ind) => {
                  return (
                    <div
                      key={ind}
                      className={`flex flex-col w-full items-center ${
                        ind == QRStyleIndex ? "bg-gray-200" : ""
                      } px-2 py-3 gap-3 rounded-md cursor-pointer`}
                      onClick={(e) => setQRStyle(e, ind)}
                    >
                      <div
                        className="flex flex-col gap-1 w-full rounded-lg items-center py-5 shadow-lg"
                        style={{
                          backgroundColor:
                            ind == 0
                              ? "white"
                              : ind == 1
                              ? colorFirst
                              : colorSecond,
                          color:
                            ind == 0
                              ? "black"
                              : ind == 1
                              ? colorSecond
                              : colorFirst,
                        }}
                      >
                        <QRCode
                          id={"qr"}
                          value={"https://app.nitomeyocard.com/me/" + slug}
                          size={130}
                          qrStyle={"dots"}
                          logoOpacity={0.15}
                          bgColor={"transparent"}
                          level={"H"}
                          fgColor={
                            ind == 0
                              ? "black"
                              : ind == 1
                              ? colorSecond
                              : colorFirst
                          }
                        />
                        <div className="font-bold text-lg">
                          {firstName || middleName || lastName
                            ? (firstName.split(" ")[0] || "") +
                              " " +
                              (lastName.split(" ").at(-1) || "")
                            : name}
                        </div>
                        <div className="text-sm">{jobPosition}</div>
                      </div>
                      <div>{val}</div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="font-bold">QR Positions</div>
              <div className="grid grid-cols-4 gap-2">
                <div
                  className={`flex flex-col rounded-lg p-3 justify-center cursor-pointer items-center gap-2 ${
                    0 == QRPositionIndex ? "bg-gray-200" : ""
                  }`}
                  onClick={(e) => handleOnClickQRPosition(e, 0)}
                >
                  <img src={top_right} alt="" />
                  <div>Top Right</div>
                </div>
                <div
                  className={`flex flex-col rounded-lg p-3 justify-center cursor-pointer items-center gap-2 ${
                    1 == QRPositionIndex ? "bg-gray-200" : ""
                  }`}
                  onClick={(e) => handleOnClickQRPosition(e, 1)}
                >
                  <img src={top_left} alt="" />
                  <div>Top Left</div>
                </div>
                <div
                  className={`flex flex-col rounded-lg p-3 justify-center cursor-pointer items-center gap-2 ${
                    2 == QRPositionIndex ? "bg-gray-200" : ""
                  }`}
                  onClick={(e) => handleOnClickQRPosition(e, 2)}
                >
                  <img src={bottom_left} alt="" />
                  <div>Bottom Left</div>
                </div>
                <div
                  className={`flex flex-col rounded-lg p-3 justify-center cursor-pointer items-center gap-2 ${
                    3 == QRPositionIndex ? "bg-gray-200" : ""
                  }`}
                  onClick={(e) => handleOnClickQRPosition(e, 3)}
                >
                  <img src={bottom_right} alt="" />
                  <div>Bottom Right</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalEditPhoto
        imgsrc={imageEdit}
        setImgSrc={funcSetEdit}
        aspect={1920 / 1080}
        circularCrop={false}
      />
    </div>
  );
};

export default UpdateBackground;
